<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
  import Next from '../icons/Next.svelte';
  import Previous from '../icons/Previous.svelte';

  import { AppState } from '../../etc/stores';
  import { isMobile } from '../../etc/utils';
  import { disableScroll, enableScroll } from '../../etc/scroll';

  let Carousel; // for saving Carousel component class

  let width = 0;

  const onResize = event => {
    width = event.currentTarget.innerWidth;
  };

  onMount(async () => {
    const module = await import('svelte-carousel');
    Carousel = module.default;
    onResize({ currentTarget: { innerWidth: window.innerWidth } });
    window.addEventListener('resize', onResize, true);

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 800);
  });

  onDestroy(() => {
    window.removeEventListener('resize', onResize, true);
  });

  const onSwipeStart = () => {
    disableScroll();
  };

  const onSwipeEnd = () => {
    enableScroll();
  };

  const isBlack = $AppState.theme.name === 'black';
  const color = isBlack ? '#DAE1EC' : undefined;
</script>

<svelte:component
  this={Carousel}
  let:showPrevPage
  let:showNextPage
  let:currentPageIndex
  let:pagesCount
  let:disabled
  widthCard={(isMobile() ? width - 64 : 296) + 16}
  infinite={false}
  {onSwipeStart}
  {onSwipeEnd}
  onSwipeThresholdReached={onSwipeEnd}
  onSwipeFailed={onSwipeEnd}
>
  <div
    slot="prev"
    on:click={showPrevPage}
    class="twism-carousel-arrow twism-carousel-arrow-prev {disabled
      ? '--disabled'
      : ''}"
  >
    {#if !isMobile()}
      <Previous color1={color} color2={color} />
    {/if}
  </div>
  <div
    slot="next"
    on:click={showNextPage}
    class="twism-carousel-arrow twism-carousel-arrow-next {disabled
      ? '--disabled'
      : ''}"
  >
    {#if !isMobile()}
      <Next color1={color} color2={color} />
    {/if}
  </div>

  <slot />

  <div slot="dots" class="twism-carousel-dots">
    {#each Array(pagesCount) as _, pageIndex (pageIndex)}
      <div
        class="twism-carousel-dot {pageIndex === currentPageIndex
          ? 'twism-carousel-dot--active'
          : ''} {isBlack ? 'twism-white' : ''}"
      />
    {/each}
  </div>
</svelte:component>

<style lang="scss">
  :global(.sc-carousel__carousel-container) {
    position: relative;
  }

  :global(.sc-carousel__content-container) {
    z-index: 3;
  }

  :global(.sc-carousel__pages-window) {
    overflow: inherit !important;
  }

  :global(.sc-carousel__pages-container) {
    &:first-child {
      margin-left: 8px;
    }

    &:last-child {
      margin-right: 8px;
    }
  }

  .twism-carousel {
    &-arrow {
      position: absolute;
      bottom: -36px;
      cursor: pointer;
      &.--disabled {
        opacity: 0.4;
        cursor: auto;
      }

      &.twism-white {
        color: #dae1ec;
      }
      &-prev {
        left: 32px;
      }
      &-next {
        right: 32px;
      }
    }

    &-dots {
      display: flex;
      position: absolute;
      bottom: -25px;

      @media screen and (max-width: 468px) and (min-height: 700px) {
        bottom: -30px;
      }
    }
    &-dot {
      width: 4px;
      height: 4px;

      background: var(--twism-theme-welcome-dotSlide);
      border-radius: 200px;

      margin: 0 2px;
      transition: width 0.2s;

      &--active {
        width: 17px;
        background: var(--twism-theme-backgroundGradient);

        &.twism-white {
          background: #dae1ec;
        }
      }
    }
  }
</style>
